import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface VerifiedDetailsState {
  status: "idle" | "loading" | "verified" | "failed";
  error: string | null;
}

const initialState: VerifiedDetailsState = {
  status: "idle",
  error: null,
};

const verifiedSlice = createSlice({
  name: "verification",
  initialState,
  reducers: {
    verifyStart(state) {
      state.status = "loading";
      state.error = null;
    },
    verifySuccess(state) {
      state.status = "verified";
    },
    verifyFailure(state, action: PayloadAction<string>) {
      state.status = "failed";
      state.error = action.payload;
    },
    resetVerification(state) {
      state.status = "idle";
      state.error = null;
    },
  },
});

export const { verifyStart, verifySuccess, verifyFailure, resetVerification } =
  verifiedSlice.actions;
export default verifiedSlice.reducer;
